import { render, staticRenderFns } from "./multipleselect2.vue?vue&type=template&id=4b0ca9e0&"
import script from "./multipleselect2.vue?vue&type=script&lang=js&"
export * from "./multipleselect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports